module.exports = __webpack_public_path__ + "img/package.fdc3203a.svg";